<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="修改密码"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="360px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
				<el-form-item label="旧密码：" prop="oldPassword">
				  <el-input
				    size="mini"
				    v-model.trim="form.oldPassword"
				    placeholder="请输入旧密码"
				    clearable
				  ></el-input>
				</el-form-item>
        <el-form-item label="新密码：" prop="pass">
				  <el-input
				    size="mini"
				    v-model.trim="form.pass"
				    placeholder="请输入新密码"
				    clearable
				  ></el-input>
				</el-form-item>
        <el-form-item label="确认密码：" prop="checkPass">
				  <el-input
				    size="mini"
				    v-model.trim="form.checkPass"
				    placeholder="请再次输入新密码"
				    clearable
				  ></el-input>
				</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { base64encode } from '@/plugin/base64.js'
import {
  userChangePassword
} from "@/api/UserManagement";
export default {
  data() {
    let validatePass = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入密码'));
        } else if(value.length < 6) {
          callback(new Error('长度至少为6位!'));
        } else {
          if (this.form.checkPass !== '') {
            this.$refs.form.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请再次输入密码'));
        } else if (value.length < 6) {
          callback(new Error('长度至少为6位!'));
        } else if (value !== this.form.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      form: {
        pass: '',
        oldPassword: '',
        checkPass: ''
      },
      rules: {
				oldPassword: [
				  {
				    required: true,
				    message: '请输入旧密码',
				    trigger: 'blur'
				  }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur', required: true}
        ],
      },
    }
  },
  props: ["userId"],
  methods: {
    handleBeforeClose(done) {
      this.$emit('cancel')
      done()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    async handleConfirm() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          const params = {
            oldPassword: base64encode(this.form.oldPassword),
            newPassword: base64encode(this.form.checkPass),
            currentUserId: this.userId
          }
          const res = await userChangePassword(params)
          if (res.code === 200) {
            this.$message.success('密码修改成功')
            this.$emit('cancel')
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/UserManagement/components/ChangePassword.vue